import { UI_TO_CMS_MAP } from '../../../common/cms/cmsLocaleConstants';

export const DEFAULT_ONE_TRUST_LANGUAGE_CODE = 'en';

/**
 * Maps Milanote app locale preferences to OneTrust locale codes.
 * These codes should match the language codes configured in OneTrust.
 */
export const APP_LOCALE_TO_ONE_TRUST_LANGUAGE_CODE_MAP: Record<string, string> = {
    [UI_TO_CMS_MAP.en]: 'en',
    [UI_TO_CMS_MAP.es]: 'es',
    [UI_TO_CMS_MAP.fr]: 'fr',
    [UI_TO_CMS_MAP.de]: 'de',
    [UI_TO_CMS_MAP.pt]: 'pt-br',
    [UI_TO_CMS_MAP.zh]: 'zh-cn',
    [UI_TO_CMS_MAP.ru]: 'ru',
    [UI_TO_CMS_MAP.pl]: 'pl',
    [UI_TO_CMS_MAP.ja]: 'ja',
    [UI_TO_CMS_MAP.nl]: 'nl',
    [UI_TO_CMS_MAP.it]: 'it',
    [UI_TO_CMS_MAP.ko]: 'ko',
};

export const getOneTrustLanguageCode = (localePreference?: string): string => {
    if (!localePreference) return DEFAULT_ONE_TRUST_LANGUAGE_CODE;

    return APP_LOCALE_TO_ONE_TRUST_LANGUAGE_CODE_MAP[localePreference] || DEFAULT_ONE_TRUST_LANGUAGE_CODE;
};
